import { render } from "./Setting.vue?vue&type=template&id=0264a6dc&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=0264a6dc&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-0264a6dc"

export default script